import {Component, OnInit} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {DirectoryService} from '../../../services/directory.service';
import {SettingsParcelsService} from '../../../services/settings-parcels.service';
import {AccountPermissionsService} from '../../../services/account-permissions.service';

declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'settings-parcels-detailed-view',
    templateUrl: './settings-parcels-detailed-view.component.html',
    styleUrls: ['./settings-parcels-detailed-view.component.scss']
})

export class SettingsParcelsDetailedViewComponent implements OnInit {
    title = 'Resident';
    disabledFileInput = false;
    navPosition = 'general';
    attachments: Array<any> = [];
    selectValues = [
        {name: 'day', displayName: 'Per Day'},
        {name: 'week', displayName: 'Per Week'},
        {name: 'month', displayName: 'Per Month'},
        {name: 'year', displayName: 'Per Year'}
    ];
    noEdit = false;
    isFromEditMode = false;
    disabledSenderSubmit = false;

    constructor(public api: ApiClientService,
                public settingsParcelsService: SettingsParcelsService,
                public account: AccountPermissionsService,
                public directoryService: DirectoryService) {
    }

    ngOnInit() {
        this.settingsParcelsService.onDetailedViewToggle.subscribe(res => this.isFromEditMode = false);
    }

    onSubmit(data: any): void {
        this.noEdit = true;
        const url = `/v1/parcel-service-settings/${this.settingsParcelsService.selectedItemData.corporationNumberBd}.json`;
        this.settingsParcelsService.api.patch('domainParcels', url, data).subscribe(
            () => this.updateView('The Field was updated successfully', false, data),
            (error) => {
                if(JSON.parse(error._body).errors && JSON.parse(error._body).errors.length > 0)
                    JSON.parse(error._body).errors.forEach(error => toastr.error(error.description));
                else
                    toastr.error('Update failed!');
            },
            () => { this.noEdit = false; }
        );
    }

    updateView(msg: string, close = true, data): void {
        if(Object.keys(data).indexOf('emailSender') != -1) {
            this.isFromEditMode = false;
            this.disabledSenderSubmit = false;
            this.settingsParcelsService.selectedItemData.emailSender = data.emailSender;
        }
        if (msg) toastr.success(msg);
        if (close) this.settingsParcelsService.toggleDetailedView(null, false);
    }

    applyChanges(item, form, changedValue, formField) {
        if (form.dirty) {
            item[formField] = form.value[formField];
            if (form.valid) this.setEditModeForAll(false);
            this.onSubmit(changedValue);
        } else {
            this.setEditModeForAll(false);
        }
    }

    setEditModeFor(item, fieldName: string, state: boolean) {
        this.setEditModeForAll(false);
        item.formFields[fieldName].editMode = state;
    }

    setEditModeForAll(state: boolean) {
        for(const field in this.settingsParcelsService.selectedItemData.formFields)
            this.settingsParcelsService.selectedItemData.formFields[field].editMode = state;
    }

    getBuildingNameById(id): string {
        let name = '';

        this.settingsParcelsService.buildings.forEach(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }

    showNotificationModal(staffOrResident, notificationType): void {
        if(staffOrResident.toLowerCase().indexOf('sms') == -1) {
            this.settingsParcelsService.isNotificationModalShow = true;
            this.settingsParcelsService.notificationModalStaffOrResident = staffOrResident;
            this.settingsParcelsService.notificationModalNotificationType = notificationType;
        } else {
            this.settingsParcelsService.isSmsNotificationModalShow = true;
            this.settingsParcelsService.notificationModalNotificationType = notificationType;
        }
    }

    submitNotificationsField(): void {
        const data = {staffNotificationSettings : [
                {
                    action: 'received',
                    enableStatus: this.settingsParcelsService.parcelReceivedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsParcelsService.receivedStaffMultiselectArray)
                },
                {
                    action: 'picked_up',
                    enableStatus: this.settingsParcelsService.parcelPickedUpStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsParcelsService.pickedUpStaffMultiselectArray)
                },
                {
                    action: 'returned',
                    enableStatus: this.settingsParcelsService.parcelReturnedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsParcelsService.returnedStaffMultiselectArray)
                },
                {
                    action: 'canceled',
                    enableStatus: this.settingsParcelsService.parcelCanceledStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsParcelsService.canceledStaffMultiselectArray)
                },
                {
                    action: 'modified',
                    enableStatus: this.settingsParcelsService.parcelModifiedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsParcelsService.modifiedStaffMultiselectArray)
                },
                {
                    action: 'deleted',
                    enableStatus: this.settingsParcelsService.parcelDeletedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsParcelsService.deletedStaffMultiselectArray)
                }
            ],
            residentsNotificationSettings : [
                {
                    action: 'received',
                    enableStatus: this.settingsParcelsService.parcelReceivedResidentCheckbox ? 1 : 0
                },
                {
                    action: 'picked_up',
                    enableStatus: this.settingsParcelsService.parcelPickedUpResidentCheckbox ? 1 : 0
                },
                {
                    action: 'returned',
                    enableStatus: this.settingsParcelsService.parcelReturnedResidentCheckbox ? 1 : 0
                },
                {
                    action: 'canceled',
                    enableStatus: this.settingsParcelsService.parcelCanceledResidentCheckbox ? 1 : 0
                },
                {
                    action: 'modified',
                    enableStatus: this.settingsParcelsService.parcelModifiedResidentCheckbox ? 1 : 0
                },
                {
                    action: 'deleted',
                    enableStatus: this.settingsParcelsService.parcelDeletedResidentCheckbox ? 1 : 0
                }
            ],
            residentsSmsNotificationSettings : [
                {
                    action: 'received',
                    enableStatus: this.settingsParcelsService.parcelReceivedSmsResidentCheckbox ? 1 : 0
                },
                {
                    action: 'picked_up',
                    enableStatus: this.settingsParcelsService.parcelPickedUpSmsResidentCheckbox ? 1 : 0
                },
                {
                    action: 'returned',
                    enableStatus: this.settingsParcelsService.parcelReturnedSmsResidentCheckbox ? 1 : 0
                },
                {
                    action: 'canceled',
                    enableStatus: this.settingsParcelsService.parcelCanceledSmsResidentCheckbox ? 1 : 0
                },
                {
                    action: 'modified',
                    enableStatus: this.settingsParcelsService.parcelModifiedSmsResidentCheckbox ? 1 : 0
                },
                {
                    action: 'deleted',
                    enableStatus: this.settingsParcelsService.parcelDeletedSmsResidentCheckbox ? 1 : 0
                }
            ]
        };
        this.onSubmit(data);
    }

    getUserRolesFormatted(arr): Array<any> {
        return arr.map(a => ({bdId: a.id, roleName: a.itemName}));
    }

    public validateValue(event) {
        return event.charCode >= 48 && event.charCode <= 57;
    }

    emailTemplateIsSet(type, action) {
        let flag = false;
        this.settingsParcelsService.selectedItemData[type + 'NotificationSettings'].forEach((setting) => {
            if(setting.action == (action == 'pickedUp' ? 'picked_up' : action))
                flag = setting.emailTemplate === null && !setting.emailTemplateOtherMessage && !setting.emailTemplateOtherSubject ? false : true;
        });
        return flag;
    }

    smsCheckboxDisabled(type, action) {
        return !this.settingsParcelsService.smsSettings.isEnable;
    }

    showReminderTextModal() {
        this.settingsParcelsService.isShowReminderTextModal = true;
    }

    showSmsReminderTextModal() {
        this.settingsParcelsService.isShowSmsReminderTextModal = true;
    }

    isChangedEmailValid(email) {
        if(!email) {
            this.onSubmit({emailSender: email});
        } else {
            if (!email.match('[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?')) {
                toastr.warning('Email is invalid');
                return;
            }
            const url = `/v1/public/check_sender/${email}`;
            this.api.get('domainNotifications', url).subscribe(
                res => {
                    const body = JSON.parse(res._body);
                    if (body.status != 'Success') {
                        toastr.error('Email is not valid');
                        swal({
                            title: 'Email is not verified',
                            text: 'We will send confirmation email to your inbox. Please click Yes to proceed, or No if you want to change email.',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No',
                            closeOnConfirm: true
                        }, () => this.sendVerificationEmail(email));
                    } else {
                        this.disabledSenderSubmit = true;
                        this.onSubmit({emailSender: email});
                    }
                },
                error => this.api.errorHandler(error, 'Failed to verify entered email.')
            );
        }
    }

    sendVerificationEmail(email) {
        const url = '/v1/public/add_sender';
        const data = {email: email};
        this.settingsParcelsService.api.post('domainNotifications', url, {email: email}).subscribe(
            () => this.updateView('Verification has been sent successfully', false, data),
            (error) => this.api.errorHandler(error, 'Failed to send verification.'),
            () => this.noEdit = false
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/settings-parcels-detailed-view/settings-parcels-detailed-view.component.ts